import api from "../api";
import Cookies from "js-cookie";
import createPersistedState from "vuex-persistedstate";

const auth_module = {
  plugins: [createPersistedState()],
  state: {
    loginStatus: false,
    infoUser: JSON.parse(localStorage.getItem("infoUser")),
    tenant: JSON.parse(localStorage.getItem("tenant") || "null"),
    tokenAuth: null,
  },
  mutations: {
    setLoginStatus(state, status) {
      state.loginStatus = status;
    },
    setInfoUser(state, infoUser) {
      state.infoUser = infoUser;
    },
    setTenant(state, tenant) {
      state.tenant = tenant;
      if (tenant) localStorage.setItem("tenant", JSON.stringify(tenant));
      else localStorage.removeItem("tenant");
    },
    setTokenAuth(state, tokenAuth) {
      state.tokenAuth = tokenAuth;
    },
  },
  actions: {
    setLogin(context, data) {
      context.commit("setLoginStatus", true);
      context.commit("setInfoUser", data.user_data);
      context.commit("setTenant", data.tenant || null);
      context.commit("setTokenAuth", data.access_token);
      api.authorization(true, data.access_token);
      Cookies.set("session_id", data.access_token);
      localStorage.setItem("infoUser", JSON.stringify(data.user_data));
    },
    async refreshUser(context) {
      try {
        const r = await api.get("auth/get-user");
        context.commit("setInfoUser", r.data);
        context.commit("setTenant", r.data.tenant || null);
        localStorage.setItem("infoUser", JSON.stringify(r.data));
      } catch (_) { /* ignore */ }
    },
    logout(context) {
      context.commit("setLoginStatus", false);
      context.commit("setInfoUser", null);
      context.commit("setTenant", null);
      context.commit("setTokenAuth", null);
      api.authorization(false);
      Cookies.remove("session_id");
      localStorage.removeItem("infoUser");
      localStorage.removeItem("tenant");
    },
  },
  getters: {
    getLoginStatus(state) {
      return state.loginStatus;
    },
    getInfoUser(state) {
      return state.infoUser;
    },
    getTenant(state) {
      return state.tenant;
    },
    getTokenAuth(state) {
      return state.tokenAuth;
    },
  },
};
export default auth_module;
